<div class="flex justify-between gap-4">
  <h2 mat-dialog-title class="text-lg font-bold mb-1">{{data.subRoute?.name}} - Viaje {{data.id}}</h2>

  <div *ngIf="this.selected == 1" class="text-end">
    <mat-form-field class="full-wid mt-1 mr-2" appearance="outline">
      <mat-select [(ngModel)]="replica" placeholder="Nro de réplicas" [ngModelOptions]="{standalone: true}"
        (selectionChange)="getManyPoints($event.value)">
        <mat-option *ngFor="let item of listQtReplicas" [value]="item">{{item}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<mat-dialog-content class="modal-content p-0">
  <mat-tab-group [selectedIndex]="selected" (selectedIndexChange)="onTabChange($event)">
    <!-- Tab Última posición -->
    <mat-tab label="Última posición">
      <div [hidden]="selected !== 0" class="w-full h-96">
        <app-geo-manager #geoManagerLast [containerId]="'mapLast'" [zoom]="13" [center]="[51.505, -0.09]"
          [markerGroups]="filteredMarkerLast" [displayMode]="'tooltip'" [captions]="{title: ''}">
        </app-geo-manager>
      </div>
    </mat-tab>

    <!-- Tab Historial de réplicas -->
    <mat-tab label="Historial de réplicas">
      <mat-tab-group [selectedIndex]="selectedInnerTab" (selectedIndexChange)="onInnerTabChange($event)">
        <mat-tab label="Mapa">
          <div [hidden]="selected !== 1" class="w-full  h-96">
            <app-geo-manager #geoManagerMany [containerId]="'mapMany'" [zoom]="13" [center]="[51.505, -0.09]"
              [markerGroups]="filteredMarkerMany" [displayMode]="'tooltip'" [captions]="{title: ''}">
            </app-geo-manager>
          </div>
        </mat-tab>
        <mat-tab label="Tabla">
          <table class="full-wid" mat-table [dataSource]="dataSourceReplica" matSort>
            <ng-container matColumnDef="location">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <div class="make-ellipse">
                  <button mat-icon-button (click)="openGoogleMap(element)">
                    <mat-icon [ngStyle]="!element?.isFakeLocation ? { color: 'green' } : {color: '#e76a26'}"
                      [matTooltip]="element?.isFakeLocation ? 'Ubicación falsa' : 'Ubicación real'">
                      location_on
                    </mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="latitude">
              <th mat-header-cell *matHeaderCellDef>Latitude</th>
              <td mat-cell *matCellDef="let element">
                <div class="make-ellipse">
                  {{element?.location?.coords?.latitude}}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="longitude">
              <th mat-header-cell *matHeaderCellDef>Longitude</th>
              <td mat-cell *matCellDef="let element">
                <div class="make-ellipse">
                  {{element?.location?.coords?.longitude}}
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha y Hora</th>
              <td mat-cell *matCellDef="let element">
                <div class="make-ellipse">
                  {{element?.timestamp}}
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <div class="text-table" *ngIf="dataSourceReplica.data.length == 0">
            <span>No hay Datos</span>
          </div>

          <div class="pagination">
            <mat-paginator [length]="dataSourceReplica.data.length" [pageSize]="10"
              [pageSizeOptions]="[10, 20, 30, 40, 50]">
            </mat-paginator>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions class="p-4 flex justify-end">
  <button mat-flat-button mat-dialog-close color="primary">Cerrar</button>
</mat-dialog-actions>